import React from 'react';
import { IClientBusinessTypeModel } from '../../../../../../../Types/ClientModelTypes';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import { ITypeTreeConditionObject } from '../../../../../../../Types/UrvalTypes';
import { setCondition } from '../../../Utils/UrvalConditionObjectUtils';
import TypeTreePickerDialogButton from '../../TypeTreePicker/TypeTreePickerDialogButton';

interface IProps {
  conditionObject: ITypeTreeConditionObject;
  businessType: IClientBusinessTypeModel;
  setConditionObject: (newConditionObject: ITypeTreeConditionObject) => void;
  deleteConditionObject: () => void;
  disabled?: boolean;
}

class TypeTreeConditionValueControl extends React.Component<IProps> {
  setCondition = (newCondition: string[]) => {
    this.props.setConditionObject(
      setCondition(newCondition, this.props.conditionObject)
    );
  };

  render() {
    const {
      conditionObject,
      setConditionObject,
      deleteConditionObject,
      disabled,
    } = this.props;

    const isHighestLevel =
      conditionObject.modelPath == null ||
      conditionObject.modelPath.length === 0;

    return (
      <div>
        {!isHighestLevel && (
          <EDIconButton
            color="inherit"
            margin="none"
            icon="remove_circle_outlined"
            onClick={deleteConditionObject}
            tooltip={`Ta bort ${conditionObject.attribute.DisplayLabel}`}
          />
        )}
        <TypeTreePickerDialogButton
          conditionObject={conditionObject}
          setConditionObject={setConditionObject}
          disabled={disabled}
        />
      </div>
    );
  }
}

export default TypeTreeConditionValueControl;
